import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InspectionService } from '../../../inspection/inspection.service';
import { SentEmail, ProductType } from '../../interfaces';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ngxLoadingAnimationTypes } from 'ngx-loading';

@Component({
  selector: 'app-view-email-modal',
  templateUrl: './view-email-modal.component.html',
  styleUrls: ['./view-email-modal.component.scss'],
})
export class ViewEmailModalComponent implements OnInit {
  @ViewChild('sendEmailModal') sendEmailModal: BsModalRef;
  EmailSent: SentEmail;
  id: number;
  letterEmail: SentEmail;
  productType: ProductType;
  emailContent: SafeHtml = '';
  loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public primaryColour = '#ffffff';
  public secondaryColour = '#ccc';

  constructor(
    private inspectionService: InspectionService,
    private sanitizer: DomSanitizer,
    public modalRef: BsModalRef,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    if (!this.letterEmail) {
      this.inspectionService.getSentEmailById(this.id).then(res => {
        this.EmailSent = res;
        this.emailContent = this.sanitizer.bypassSecurityTrustHtml(this.EmailSent.body);
        this.loading = false;
      });
    } else {
      this.EmailSent = this.letterEmail;
      this.emailContent = this.sanitizer.bypassSecurityTrustHtml(this.letterEmail.body);
      this.loading = false;
    }
  }
  closeModal() {
    this.modalRef.hide();
  }

  async downloadEmail(letterEmail: SentEmail) {
    this.inspectionService.downloadSentEmail(letterEmail.id).then(data => {
      const blob = new Blob([data as any], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'RecLetterEmail.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
